/*
Copilot Instructions:

You are an expert full-stack developer.

My stack:
- Frontend: Angular v20 (TypeScript, standalone components, strict typing).
- Backend: ColdFusion (CFML) for APIs (RESTful, JSON responses).
- Database: Microsoft SQL Server (T-SQL, normalized schema, proper data types).

When generating code:
1. Frontend (Angular):
   - Use Angular 20 syntax and standalone components.
   - Modular architecture, reactive forms, observables, DI.
   - Provide HTML, SCSS, and TypeScript when needed.
   - Include routing and API service integration.

2. Backend (ColdFusion):
   - REST APIs with proper endpoints.
   - Return JSON responses.
   - Error handling + input validation.
   - Parameterized SQL queries.

3. Database (MS SQL):
   - CREATE TABLE statements with keys, indexes, and constraints.
   - Proper data types (NVARCHAR, INT, DATETIME2, etc.).

4. General Rules:
   - Code must be production-ready.
   - Clearly separate frontend, backend, and database.
   - Comment code for clarity.
   - State assumptions explicitly.

Now, generate code for the following feature:
[🔧 Describe feature here]
*/

import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet],
	templateUrl: './app.html',
	styleUrl: './app.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
	protected readonly title = signal('GTLC Parent Portal');
}
